/**
 * Centralized environment configuration — the only module that reads
 * `import.meta.env` directly (see vite-env.d.ts for the typed keys).
 * Everything else imports the values it needs from here instead of
 * touching `import.meta.env` itself.
 */

const DEFAULT_API_BASE_URL = "http://localhost:8000/api";

/** Base URL every API request is made against ("/api" in dev, proxied — see vite.config.ts). */
export const API_BASE_URL: string = import.meta.env.VITE_API_URL || DEFAULT_API_BASE_URL;

/**
 * Origin the API is served from, with a trailing slash — resolves relative
 * storage/upload paths (e.g. "uploads/x.jpg") returned by the API into
 * absolute URLs.
 */
export const ASSET_BASE_URL: string = API_BASE_URL.replace(/\/api.*$/, "/");

export const PUSHER_APP_KEY: string | undefined = import.meta.env.VITE_PUSHER_APP_KEY;
export const PUSHER_APP_CLUSTER: string | undefined = import.meta.env.VITE_PUSHER_APP_CLUSTER;

/**
 * Resolves a storage/upload path returned by the API into an absolute URL.
 * Already-absolute (http/https) paths pass through unchanged. Callers own
 * their own falsy-input handling (empty/undefined/null) since that varies
 * by call site — this only does the actual path-to-URL transform.
 */
export const resolveAssetUrl = (path: string): string =>
  path.startsWith("http") ? path : ASSET_BASE_URL + path.replace(/^\/+/, "");
